import React, { useState } from 'react';
import Rails from 'rails-ujs';
import axios from 'axios';

type Props = {
  userUid: string,
  defaultRealizedProfitText: string|null,
  defaultCalculatedAtText: string|null,
  defaultCalculatedAgoText: string|null,
};

const UserRealizedProfitCell: React.FC<Props> = ({
  userUid,
  defaultRealizedProfitText,
  defaultCalculatedAtText,
  defaultCalculatedAgoText,
}) => {
  const [realizedProfitText, setRealizedProfitText] = useState<string|null>(defaultRealizedProfitText);
  const [calculatedAtText, setCalculatedAtText] = useState<string|null>(defaultCalculatedAtText);
  const [calculatedAgoText, setCalculatedAgoText] = useState<string|null>(defaultCalculatedAgoText);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleUpdate = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const url = `/admin/users/${userUid}/refresh_profit_total`;
      const response = await axios.put(url, {
        authenticity_token: Rails.csrfToken(),
      }, {
        timeout: 8000,
      });
      if (response.status === 200) {
        setRealizedProfitText(response.data.realizedProfitText);
        setCalculatedAtText(response.data.calculatedAtText);
        setCalculatedAgoText(response.data.calculatedAgoText);
        setIsLoading(false);
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (e) {
      setIsLoading(false);
      alert('実損益合計の更新に失敗しました');
      console.log(e);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-end align-items-center">
        <span>{realizedProfitText !== null ? `$${realizedProfitText}` : '未集計'}</span>
        {isLoading ? (
          <span className="text-muted ms-1"><i className="fas fa-sync-alt fa-spin" aria-hidden="true"></i></span>
        ) : (
          <button
            type="button"
            onClick={handleUpdate}
            className="btn btn-link p-0 border-0 ms-1 align-baseline"
            aria-label="実損益合計を更新">
            <i className="fas fa-sync-alt" aria-hidden="true"></i>
          </button>
        )}
      </div>
      {calculatedAgoText && (
        <div
          title={calculatedAtText ?? undefined}
          className="text-muted"
          style={{ fontSize: '0.75rem' }}>
          {calculatedAgoText}
        </div>
      )}
    </>
  );
};

export default UserRealizedProfitCell;
